import * as BosFilesServices from "data/BosWebServices/BosFilesServices";

const UPLOAD_CHUNK_SIZE = 5 * 1024 * 1024;

export function DownloadPreview(fileId, dataSegmentAuthToken) {
  return new Promise((resolve, reject) => {
    downloadPreview(fileId, dataSegmentAuthToken)
    .then(fileId => {
      resolve(fileId);
    })
    .catch(error => {
      reject(error);
    });
  });
}

const downloadPreview = async (fileId, dataSegmentAuthToken) => {
  let previewResult = await BosFilesServices.fetchDownloadPreview(dataSegmentAuthToken, fileId);
  return previewResult;
}

export function UploadFile(file, dataSegmentAuthToken, dataSegmentId) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = function () {
      upload(reader.result, file.name, dataSegmentAuthToken, dataSegmentId)
        .then(fileId => {
          resolve(fileId);
        })
        .catch(error => {
          reject(error);
        });
    };
    reader.readAsArrayBuffer(file);
  });
}

const upload = async (data, fileName, dataSegmentAuthToken, dataSegmentId) => {
  let total = data.byteLength;

  let initResult = await BosFilesServices.fetchInitUpload(dataSegmentAuthToken, dataSegmentId, fileName, total);
  let error = initResult.errorMessage;
  if (error) throw new Error(error);
  let fileId = initResult.fileId;

  let offset = 0;
  let partNo = 1;
  let chunkLength = UPLOAD_CHUNK_SIZE;

  while (offset < total) {
    // adjust the last chunk size
    if (offset + chunkLength > total) {
      chunkLength = total - offset;
    }

    var rawChunk = new Uint8Array(data, offset, chunkLength);
    let part = ui8ArrayToBase64(rawChunk);

    console.log("Sending part: " + partNo + " with content", part);
    let partResult = await BosFilesServices.fetchUploadPart(dataSegmentAuthToken, fileId, partNo, chunkLength, null, part);
    let partError = partResult;
    if (partError) throw new Error(error);

    offset += chunkLength;
    partNo++;
  }
  return fileId;
}

export function DownloadFile(fileId, dataSegmentAuthToken) {
  throw new Error("NOT SUPPORTED ANYMORE. USE getWebResourceUrl INSTEAD!");
}

function ui8ArrayToBase64(ui8Array) {
  let binary = '';
  let len = ui8Array.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(ui8Array[i]);
  }
  return btoa(binary);
}

function base64ToUi8Array(base64) {
  var raw = atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));
  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}

export function ToDataSource(base64Content, contentType) {
  return "data:" + (contentType || "image/gif") + ";base64," + base64Content;
}

export function StartBrowserDownload(base64Content, filename, mimeType) {
  let fileContent = base64ToUi8Array(base64Content);
  const blob = new Blob([fileContent], {type: mimeType});
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  a.click();
  URL.revokeObjectURL(url);
}

export function StartBrowserOpen(base64Content, mimeType) {
  let fileContent = base64ToUi8Array(base64Content);
  const blob = new Blob([fileContent], {type: mimeType});
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  URL.revokeObjectURL(url);
}

export function StartBrowserDownloadUrl(url, filename) {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  a.click();
  URL.revokeObjectURL(url);
}

export function StartBrowserOpenUrl(url) {
  window.open(url, "_blank");
  URL.revokeObjectURL(url);
}